import { Navigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useTimeout } from 'usehooks-ts'

import {
  usePostHogFeatureFlag,
  useFeatureFlagsReady,
  PostHogFeatureFlag
} from '@percent/admin-dashboard/common/hooks/usePostHogFeatureFlag'
import { Spinner } from '@percent/lemonade'
import { useAuthState } from '@percent/admin-dashboard/common/hooks'
import { ROUTE_GUARD_WAIT_MS } from '@percent/admin-dashboard/constants/routeGuardTiming'
import { DEFAULT_ROUTE } from './default-route'

export type FeatureRouteProps = {
  flag: PostHogFeatureFlag
  children: React.ReactNode
}

export function FeatureRoute({ flag, children }: FeatureRouteProps) {
  const isReady = useFeatureFlagsReady()
  const flagValue = usePostHogFeatureFlag(flag)
  const { permissionsSet } = useAuthState()

  const [loaded, setLoaded] = useState(false)
  const [haveWaited, setHaveWaited] = useState(false)

  useEffect(() => {
    if (permissionsSet && isReady && !loaded) {
      setLoaded(true)
    }
  }, [isReady, loaded, permissionsSet])

  // if not set after 2 seconds, indicate we should not wait for permissions to be set
  useTimeout(() => {
    setHaveWaited(true)
  }, ROUTE_GUARD_WAIT_MS)

  useEffect(() => {
    if (!loaded && haveWaited && isReady) {
      setLoaded(true)
    }
  }, [haveWaited, isReady, loaded])

  if (loaded && !flagValue) {
    return <Navigate data-testid="redirect" to={DEFAULT_ROUTE} replace />
  }

  if (flagValue) {
    return <>{children}</>
  }

  return <Spinner size="m" />
}
